// KAN-724 — cutover dos CTAs Zenthor: waitlist → signup no D-day.
//
// A flag `NEXT_PUBLIC_ZENTHOR_LAUNCHED` controla todos os CTAs principais:
// - false (default) → CTA abre `WaitlistModal` (pré-lançamento)
// - true            → CTA vira link direto para o signup do produto
//
// É uma env var pública (Next.js inlining em build time), então o cutover
// é feito setando a var no DigitalOcean App Platform e disparando um
// redeploy. Sem migração, sem coordenação extra.

export const ZENTHOR_SIGNUP_URL = "https://zenthor.vorseum.com/signup";

export function isZenthorLaunched(): boolean {
  // Zenthor está EM PRODUÇÃO (zenthor.vorseum.com no ar). Lançado por padrão;
  // só volta pro modo waitlist se a env for explicitamente "false". Antes o
  // default era pré-lançamento (waitlist), e sem a env setada no build os CTAs
  // ficavam presos na lista de espera mesmo com o produto já no ar.
  return process.env.NEXT_PUBLIC_ZENTHOR_LAUNCHED !== "false";
}

export function zenthorCtaHref(coupon?: string | null): string {
  if (!coupon) return ZENTHOR_SIGNUP_URL;
  return `${ZENTHOR_SIGNUP_URL}?coupon=${encodeURIComponent(coupon)}`;
}
